import axiosInstance from '@/plugins/api/axiosInstance';
import generateQueryParams from '@/utils/generateQueryParams';

export default function poBox() {
    const appUrl = import.meta.env.VITE_APP_URL;

    return {
        index,
        get,
        create,
        remove,
        createExisting,
        newPublic
    };

    function index(options = {}) {
        const defaultValues = {
            pattern: '',
            limit: 25,
            page: 1
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`pobox/search${params}`);
    }

    function get(id) {
        return axiosInstance.get(`pobox/get?id=${id}`);
    }

    function create(payload) {
        let data = new FormData();

        for (let key in payload) {
            const value = payload[key];

            if (value === undefined) {
                data.append(key, null);
            } else {
                if (key === 'image' && value) {
                    data.append(key, value);
                } else {
                    data.append(key, value);
                }
            }
        }

        const config = {
            method: 'post',
            url: 'pobox/create',
            headers: {
                'Content-Type': `multipart/form-data`
            },
            data: data
        };

        return axiosInstance(config)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.error(error);
                throw error.data;
            });
    }

    function newPublic(payload) {
        let url = `${appUrl}/public/new_pobox_with_recaptcha`;
        return axiosInstance.post(url, payload);
    }

    function createExisting(payload) {
        let data = new FormData();

        for (let key in payload) {
            const value = payload[key];

            if (value === undefined) {
                data.append(key, null);
            } else {
                if (key === 'image' && value) {
                    data.append(key, value);
                } else {
                    data.append(key, value);
                }
            }
        }

        const config = {
            method: 'post',
            url: 'pobox/create-existing-customer',
            headers: {
                'Content-Type': `multipart/form-data`
            },
            data: data
        };

        return axiosInstance(config)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.error(error);
                throw error.data;
            });
    }

    function remove(id) {
        return axiosInstance.delete(`pobox/delete`, {
            data: id
        });
    }
}
